import React, { useState } from "react";
import { BiPlay } from "react-icons/bi";

const About = () => {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div className="relative flex flex-wrap min-h-screen gap-2 md:mt-4 bg-secondary">
      {/* Text Section */}
      <div className="flex-1 basis-[20rem] text-slate-100 px-[3%] md:px-[6%] mt-20">
        <h1 className="text-4xl font-bold capitalize lg:text-5xl">
          Pool Home Care: <br /> Your Trusted Partner in Pool Services
        </h1>
        <div className="pl-3 mt-5 border-l-4 border-primary">
          <p>
            At <strong>Pool Home Care</strong>, we specialize in creating and maintaining exceptional pools tailored to your needs.  
            Whether you're dreaming of a luxurious infinity pool or a cozy backyard oasis, our experts are here to turn your vision into reality.  
            <br />
            <br />
            Our comprehensive services include pool maintenance, cleaning, and repair, ensuring your pool stays safe, clean, and ready for year-round enjoyment.  
            With <strong>Pool Home Care</strong>, you can relax knowing your pool is in the hands of experienced professionals dedicated to quality and reliability.
          </p>
        </div>
        <div className="mt-6 flex items-center gap-x-3">
          <a href="/contact">
            <button className="btn btn-primary">Contact Us</button>
          </a>
          <button
            onClick={() => setShowVideo(true)}
            className="icon-box !opacity-100 relative before:w-full before:absolute before:h-full before:rounded-full before:bg-[#0176b4] hover:!bg-[#003b5b] before:animate-ping bg-[#035581]"
          >
            <BiPlay />
          </button>
        </div>
      </div>

      {/* Image or Video Section */}
      <div className="flex-1 basis-[20rem] h-full">
        {showVideo ? (
          <div className="w-full h-[100vh] bg-black flex items-center justify-center">
            <video
              className="w-full h-full object-cover"
              loading="lazy"
              controls
              muted
              autoPlay
              loop
              controlsList="nodownload"
            >
              <source
                src="/images/services/video.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        ) : (
          <img
            src="/images/services/about.jpg"
            alt="Pool Home Care Services"
            className="w-full h-fit sm:h-[100vh] object-cover"
          />
        )}
      </div>
    </div>
  );
};

export default About;
